import React from 'react';
import { Size } from '../../../../Enums/Size.enum';
import Modal from '../../../../Components/Modal/Modal';
import PatientsGroupsMembers from './PatientsGroupsMembers';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	groupId: string;
}

const PatientsGroupsMembersModal: React.FC<Props> = ({
	isOpen,
	onClose,
	groupId,
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} size={Size.FULLSCREEN}>
			<Modal.Header title='component.groupMsgs.membersInGroup' firstUpper />
			<Modal.Content contentStyle={{ padding: 0 }}>
				<PatientsGroupsMembers groupId={groupId} />
			</Modal.Content>
		</Modal>
	);
};

export default PatientsGroupsMembersModal;
